<template>
    <div class="container">
        <div class="content">

            <section v-if="state == 'error'">

                <p class="gif-container">
                    <img src="https://api.quomi.it/oldimg/albero-piantato.gif">
                </p>

                <div>
                    <h2
                        class="center"
                        v-html="`Ops! Si è verificato un errore`"
                    />
                    <p>
                        Si è verificato un errore: {{ error }}.
                    </p>
                    <div>
                        
                        <CTA
                            class="ma-auto"
                            :size="`small`"
                            @click="preauthorization()"
                            :content="'Riprova'"
                        />

                    </div>
                </div>
            </section>
            <section v-if="state == 'preauthorization'">

                <p class="gif-container">
                    <img src="https://api.quomi.it/oldimg/albero-piantato.gif">
                </p>

                <div>
                    <h2
                        class="center"
                        v-html="`Verifica in corso`"
                    />

                    <loading-spin :height='100'></loading-spin>
                </div>
            </section>
            <section v-if="state == 'confirmed'">
                <p class="gif-container">
                    <img src="https://api.quomi.it/oldimg/albero-piantato.gif">
                </p>

                <div>
                    <h2
                        class="center"
                        v-html="`Grazie per il tuo ordine!`"
                    />

                    <p class="label">&#127795; Con quest’ordine pianteremo un nuovo albero &#127795;</p>

                    <p>
                        Addebiteremo <strong>{{ order && totalPrice | priceFilter }}</strong> sul tuo conto {{ order && dateCheckout }}.<br>
                        <!--Potrai sempre modificare il piano, le ricette, la consegna e l'indirizzo di spedizione fino a {{ order && $_dates_dateCutOff }}<br>-->
                        <br>
                        <span v-if="$root.source !== 'enel'">
                           <i class="fa fa-truck" v-if="$root.source !== 'enel'"/> La consegna è prevista per il giorno <strong >{{ order && $_dates_readableDate(order.date.delivery) }}</strong> nella fascia <strong>{{ readable.hours }}</strong> 
                          
                        </span>
                        <span v-else>Grazie per aver scelto di partecipare a <b>#DONALASPESA</b> di <b>Enel</b> ed <b>Edenred</b> insieme possiamo contribuire alla missione di <b>Banco Alimentare</b>!</span>
                        <br>

                        <span
                          v-if="(address && delivery)"
                        >
                            a <span>{{ delivery.name }}, </span> <span v-if="address.name">{{ address.name }}, </span> <span>{{ address.street }}, {{ address.zip_code }}, {{ address.city }}</span>
                        </span>

                    </p>
                </div>

               <!-- <div
                    class="link-detail"
                    @click="showDelivery = !showDelivery"
                >
                    <b style='font-size: 17px'>+ Vuoi modificare il giorno o l'indirizzo di consegna? Clicca qui</b>
                </div>
                <change-delivery v-show="showDelivery" />-->
                <hr style="max-width: 600px">
                <div v-if="$root.source !== 'enel'">
                    <div class="mb-10" v-if="recurring && recurring.enabled">
                        <h2 class="text-center">Complimenti, hai ottenuto la consegna gratuita!</h2> 
                        <p class="text-center">Grazie all'abbonamento hai risparmiato le spese di consegna per il tuo ordine</p>
                        <div class="text-center">
                            <img src="https://api.quomi.it/oldimg/Homepage3_v2.png" width='300'/>
                    </div>
                    </div>
                    <subscription-recurring-change v-else :extra="true" thank-you-page class="pt-5 ma-auto tag-partner" style="max-width: 600px"/>
                </div>
                <!--<br><br>
                <div
                    class="link-detail"
                    @click="$refs.couponSection.toggle()"
                >
                    <b>{{ $t("components.payment.coupon_link") }}</b>
                </div>-->

                <!--<add-coupon
                    :centered="true"
                    ref="couponSection"
                    v-if="order"
                    :openedOnLoad='false'
                    :order.sync="order"
                    :redirect="true"
                    @refresh="preauthorization()"
                />

                <edenred :force="true"/>-->

                <!--<br><br>
                <p>
                    <router-link
                        :to="{name: 'profile_shipment'}"
                        class="link-detail"
                    >
                        <i aria-hidden="true" class="fas fa-user" />&nbsp; Modifica indirizzo e giorno di consegna
                    </router-link>
                </p>-->

                <div
                    v-if="!isEcommerce && $root.source !== 'enel'" 
                    class="shadow-box container-faq"
                >
                    <h3
                        class="center"
                        v-html="$mq.isDesktop() 
                            ? 'Dimenticato qualcosa?'
                            : 'Dimenticato qualcosa?'"
                    />

                    <span>Aggiungi i tuoi preferiti alla tua spesa, hai tempo fino a {{ order && dateCheckout }}!</span>
                    <!-- <ecommerce-slider />
      
                    <router-link
                        :to="{ name: 'flow-subscribed'}"
                        class="flex flex-center"
                    >
                        <CTA
                            :content="`Aggiungi prodotti`"
                            :color="`orange`"
                        />
                    </router-link> -->
                    <router-link
                        v-if="$root.source === 'default'"
                        :to="{ name: 'dashboard' }"
                        class="flex flex-center mt-5"
                    >
                        <CTA
                            :content="`Vai su My Quomi`"
                        />
                     </router-link>

                    <router-link
                        v-else
                        :to="{ name: 'profile_orders' }"
                        class="flex flex-center mt-5"
                    >
                        <CTA
                            :content="`Vai alle mie spese`"
                        />
                    </router-link>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import EcommerceSlider from '../Ecommerce/EcommerceSlider'
import AddCoupon from './AddCoupon'
import Edenred from './Edenred'

import { dates } from '../../mixins/dates'
import { prices } from '../../mixins/prices'

import { container } from '../../services/container'

import CTA from '../Elements/CTA'
import { orderStore } from '../../store/orderStore'
import ChangeDelivery from '../Delivery/ChangeDelivery'
import { deliveryStore } from '../../store/deliveryStore'
import { Order } from '../../core/Order'
import { User } from '../../core/User'
import SubscriptionRecurringChange from './SubscriptionRecurringChange'


export default {
	components: {
    SubscriptionRecurringChange,
    ChangeDelivery,
    EcommerceSlider,
	AddCoupon,
    Edenred,
    CTA
	},

	mixins: [
        dates,
        prices
    ],

	data () {
		return {
      prio: true,
      state: 'loading',
      showDelivery: false,
      deliveryStore: deliveryStore.state,
      extras: null,
      error: null,
      order: null,
      user: null,
      readable: {
        hours: null
      }
		}
	},

	computed: {
    edenredState () {
        return {
            confirmed: this.orderHasEdenred,
            estimated: this.edenredTicketEstimated,
            authorized: this.edenredTicketEstimated || this.orderHasEdenred
        }
    },
    address () {

        return this.delivery
            && this.deliveryStore
            && this.deliveryStore.address.delivery.find(r => +r.id === this.delivery.address_id)
            && this.deliveryStore.address.delivery.find(r => +r.id === this.delivery.address_id).attributes
    },

    delivery () {
        var sub = this.user.subscription
        return this.deliveryStore
            && this.deliveryStore.deliveries.order.find(r => orderStore.state.order && r.attributes.target_id === orderStore.state.order.id)
            && this.deliveryStore.deliveries.order.find(r => orderStore.state.order && r.attributes.target_id === orderStore.state.order.id).attributes
    },


    dateCheckout () {
    	return this.$_dates_readableDate(this.order.date.checkout)
    },

    isEcommerce () {
    	return this.$route.name === 'thank-you-ecommerce' || this.$route.name === 'ecommerce'
    },

    alreadySeen () {
        if (!this.order || !this.order.id) return false
        return container.get('services.cookies').get('typeform_ty') === this.order.id.toString()
    },

    recurring() {
        if(!this.user.recurring) {
            return null
        }

        try {
          return typeof this.user.recurring === 'string' ? JSON.parse(this.user.recurring) : this.user.recurring
        } catch (e) {
          return null;
        }
    }
	},

    methods: {
        preauthorization () {
            if (this.user.subscription.payment_method === 'credit card') {

                this.state = 'preauthorization';

                orderStore.preauthorization().then(i => {
                    this.confirmed();
                }).catch(error => {
                    this.errorState(typeof error === 'string' ? error : (error && error.body ? error.body.message: ''))
                })
            } else {
                this.confirmed();
            }
        }, 

        errorState (msg) {
            this.error = msg
            this.state = 'error';
        },
        confirmed () {
            this.readable.hours = this.$_date_readableDateHour();
            orderStore.confirmOrder().then(i => {
                this.state = 'confirmed';
            }).then(i => {
                this.$root.updateUser(window.user)
            }).then(i => {
                window.dispatchEvent(new CustomEvent('quomi.event', { 
                    bubbles: true, 
                    detail: {
                      name: 'purchase',
                      vars: {
                        order: orderStore.state.order,
                      }
                    } 
                 }));
            }).then(i => {
                this.user.order = null;
                orderStore.state.order = null;
                orderStore.state.orderParams = {}
                this.$root.updateUser(this.user)
            }).catch(error => {
                this.errorState(typeof error === 'string' ? error : (error && error.body ? error.body.message: ''))
            })
        },
        getRealOrder()
        {
            return this.$root.user && this.$root.user.order ? this.$root.user.order : null
        }
    },

    mounted () {
        this.state = 'preauthorization';

        // force refresh user
        let order = this.getRealOrder()

        if (!order) {
            this.$router.push({name: 'flow-subscribed'})
            return;
        }

        orderStore.state.order = order;
        orderStore.retrieveOrder().then(i => {
            this.order = new Order(JSON.parse(JSON.stringify(orderStore.state.order)))
            this.user = new User(JSON.parse(JSON.stringify(this.$root.user)))
            this.preauthorization();
        })

        let cookies = container.get('services.cookies');
        cookies.remove('people');
    }
}

</script>

<style scoped>
    .label {
        background-color: #fbf1d7;
        max-width: 500px;
        margin: 0 auto;
        margin-bottom: 10px;
    }

    .content {
        padding: 30px 15px 30px 15px;
        text-align: center;
        width: 100%;
        max-width: 100%;
    }

    .gif-container {
        width: 100px;
        height: 100px;
        margin: 0 auto;
        border-radius: 50%;
        overflow: hidden;
        margin-bottom: 20px;
    }

    .gif-container img {
        max-width: inherit;
        margin-left: -16px;
    }

    .container-faq {
        max-width: 1200px;
        width: 90%;
        margin: 0 auto;
        padding: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    h2 {
        padding-bottom: 10px;
    }

    h3 {
        font-size: 20px;
    }

    .red-text {
        margin: 0 auto;
        display: block;
        font-size: 15px;
        font-weight: bold;
    }

    section {
        padding: 0px 0;
        width: 100%;
        margin: 0 auto;
    }
</style>
